import React, { useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'

const AddDr = () => {

    const location = useLocation();
    const item: any = location?.state;

    const navigate = useNavigate()
    const [drName, setDrName] = useState<string>("" || item?.name)
    const [drCity, setDrCity] = useState<string>("" || item?.city)
    const [loading, setLoading] = useState<boolean>(false)

    // const [MrData, setMrData] = useState<any[]>([])
    const [selectData, setSelectData] = useState<string>("" || item?.employee_id);

    // console.log("item", item)
    // useEffect(() => {
    //     getMrList()
    // }, [])

    // const getMrList = () => {
    //     const getMRObj = {
    //         method: "get_mr_list",
    //     };
    //     fetch(`${process.env.REACT_APP_API_URL_MAIN}get_mr_list`, {
    //         method: "POST",
    //         headers: {},
    //         body: JSON.stringify(getMRObj),
    //     })
    //         .then((result) => {
    //             result.json().then((response) => {
    //                 if (response.status === 1) {
    //                     setMrData(response?.data.sort((a: any, b: any) =>
    //                         a.mr_name.localeCompare(b.mr_name)));
    //                 }
    //             });
    //         })
    // };

    const addDrClick = () => {
        setLoading(true)
        const DrObj = window.location.pathname === "/admin/edit_doctor" ? {
            method: "edit_doctor",
            name: drName,
            city: drCity,
            employee_id: selectData,
            doctor_id: item?.id,
        } : {
            method: "add_doctor",
            name: drName,
            city: drCity,
            employee_id: selectData,
        }

        fetch(`${process.env.REACT_APP_API_URL_MAIN}${window.location.pathname === "/admin/edit_doctor" ? 'update_doctor_details' : 'add_doctor'}`, {
            method: "POST",
            headers: {},
            body: JSON.stringify(DrObj),
        })
            .then((result) => {
                result.json().then((response) => {
                    if (response.status === 1) {
                        setLoading(false)
                        window.location.pathname === "/admin/edit_doctor" ?
                            toast.success("Doctor edited successfully", {
                                position: "top-center",
                            }) :
                            toast.success("Doctor added successfully", {
                                position: "top-center",
                            })
                        navigate(-1)
                    }
                    else {
                        setLoading(false)
                        toast.success("Action failed !!", {
                            position: "top-center",
                        });
                    }
                });
            })
    }

    return (
        <div className='h-100 w-full d-flex justify-content-center align-items-center ' >
            <div className='h-50 w-50 d-flex justify-content-center align-items-center' style={{ backgroundColor: ' #ffff', borderRadius: '8px' }} >
                <div className='d-flex flex-column w-75 justify-content-between' >
                    <div className='mb-4  d-flex justify-content-between align-items-center' >
                        <label className='form-label fs-6 fw-bolder text-dark' style={{ fontFamily: 'Poppins' }} >Doctor Name</label>
                        <input className='search-input'
                            value={drName}
                            onChange={(e) => setDrName(e?.target?.value)}
                            placeholder=' Doctor Name '
                            style={{ outline: 'none', width: '300px', borderRadius: '8px', border: 'solid #F2F2F2 1px', fontSize: '16px', padding: '8px' }} />
                    </div>
                    <div className='mb-4 d-flex justify-content-between align-items-center' >
                        <label className='form-label fs-6 fw-bolder text-dark' style={{ fontFamily: 'Poppins' }} >City</label>
                        <input className='search-input'
                            value={drCity}
                            onChange={(e) => setDrCity(e?.target?.value)}
                            placeholder={` Doctor's City `}
                            style={{ outline: 'none', width: '300px', borderRadius: '8px', border: 'solid #F2F2F2 1px', fontSize: '16px', padding: '8px' }} />
                    </div>
                    <div className=' d-flex justify-content-between align-items-center' >
                        <label className='form-label fs-6 fw-bolder text-dark' style={{ fontFamily: 'Poppins' }} > MR ID </label>
                        <input className='search-input'
                            value={selectData}
                            onChange={(e) => setSelectData(e?.target?.value)}
                            placeholder={` MR ID `}
                            style={{ outline: 'none', width: '300px', borderRadius: '8px', border: 'solid #F2F2F2 1px', fontSize: '16px', padding: '8px' }} />
                        {/* <select
                            className='form-select-solid w-300px w-xxl-300px p-3'
                            data-control='select2'
                            data-placeholder='Filter by zone'
                            data-hide-search='true'
                            // defaultValue={selectData}
                            value={selectData}
                            onChange={(e) => { setSelectData(e?.target?.value) }}
                            style={{ border: 'solid #D4D7ED 1px', borderRadius: '8px', outline: 'none' }}
                        >
                            <option value='' hidden >MR Name</option>
                            {
                                MrData?.map((item: any, index: number) => {
                                    return (
                                        <option key={index} value={`${item?.employee_id}`}>{item?.mr_name}</option>
                                    )
                                })
                            }
                        </select> */}
                    </div>
                    <div className='p-10 d-flex justify-content-evenly align-items-center'>
                        <button onClick={() => navigate(-1)} style={{ borderRadius: '8px', backgroundColor: '#0071BB', color: '#ffff', border: 'none', padding: '8px', fontFamily: 'Poppins', fontSize: '16px', width: '80px', height: 'max-content' }} >Cancel</button>
                        <button disabled={(drName === "") || (drCity === "") || (selectData === "")} onClick={() => addDrClick()} style={{ borderRadius: '8px', backgroundColor: '#0071BB', color: '#ffff', border: 'none', padding: '8px', fontFamily: 'Poppins', fontSize: '16px', width: '80px', height: 'max-content' }} >
                            {!loading && window.location.pathname === "/admin/edit_doctor" ? <span className='indicator-label'>Save</span> : <span className='indicator-label'>Add</span>}
                            {/* {loading && (
                                <span className='indicator-progress position-absolute' style={{ display: 'block' }}>
                                    <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                                </span>
                            )} */}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default AddDr